import CourseService from '@/services/course.service';
import axios from "axios";

export const courseModule = {
    namespaced: true,
    state: {
        requests: [],
        course: {},
        courses: new Map()
    },
    actions: {
        clearRequest({state}, name) {
            state.requests = state.requests.filter(obj => obj.requestName !== name);
        },
        makeOrCancelRequest({state}, name) {
            const requestExist = state.requests.find((item) => {
                return item.requestName === name ? item : null
            })

            if (requestExist)
                requestExist.cancel()

            const axiosSource = axios.CancelToken.source();

            state.requests = state.requests.filter(obj => obj.requestName !== name);
            state.requests.push({requestName: name, cancel: axiosSource.cancel});

            return axiosSource;
        },
        async createCourse({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createCourse");
            return CourseService.createCourse(axiosSource, data).then(
                async data => {
                    commit('insertCourse', data)
                    await dispatch('clearRequest', "createCourse");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateCourse({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateCourse");
            return CourseService.updateCourse(axiosSource, data).then(
                async data => {
                    commit('updateCourseData', data)
                    await dispatch('clearRequest', "updateCourse");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteCourse({commit, dispatch}, courseId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteCourse");
            return CourseService.deleteCourse(axiosSource, courseId).then(
                async data => {
                    commit('removeCourseFromList', courseId)
                    await dispatch('clearRequest', "deleteCourse");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async getCourse({commit, dispatch}, courseId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "getCourse");
            return CourseService.getCourse(axiosSource, courseId).then(
                async data => {
                    commit('updateActiveCourse', data)
                    await dispatch('clearRequest', "getCourse");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listCourses({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listCourses");
            return CourseService.listCourses(axiosSource).then(
                async data => {
                    commit('updateCoursesList', data);
                    await dispatch('clearRequest', "listCourses");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        updateCoursesList(state, data) {
            state.courses = new Map()
            for (const entity of data) {
                state.courses.set(entity.id, entity)
            }
        },
        insertCourse(state, data) {
            state.courses.set(data.id, data)
        },
        updateCourseData(state, data) {
            state.courses.set(data.id, data)
        },
        removeCourseFromList(state, courseId) {
            state.courses.delete(courseId)
        },
        updateActiveCourse(state, data) {
            state.course = data;
        }
    }
};